<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="plc ||  $t('message.region')"
    filterable
    clearable
    :size="size"
    class="d-block"
  >
    <el-option
      v-for="region in regions"
      :key="region.id"
      :label="region.name"
      :value="region.id"
    ></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import inventory from "@/utils/mixins/components/inventory";

export default {
  mixins: [inventory],
  props: ["region_id"],
  watch: {
    region_id: {
      handler: function () {
        this.dispatch(this.region_id);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.regions && this.regions.length === 0) {
      this.getInventory();
    }
  },
  computed: {
    ...mapGetters({
      regions: "regions/inventory",
    }),
  },
  methods: {
    ...mapActions({
      getInventory: "regions/inventory",
    }),
   
  },
};
</script>